// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const kennitala: CountryValidator<"IS"> = createValidator(
  "is.kennitala",
  102,
);

export default kennitala;
export const compact = kennitala.compact;
export const format = kennitala.format;
export const validate = kennitala.validate;
export const generate = (): string =>
  kennitala.generate?.() ??
  (() => {
    throw new Error(
      "Validator is.kennitala cannot generate values",
    );
  })();
